import { Component, Host, h, Prop } from '@stencil/core';
import { ButtonAppearance } from '../rcm-button/rcm-button.types';
import { Ratio, RcmImageProp } from '../rcm-image/rcm-image.types';
import { Multilink, Target } from '../types/link.types';
import { StringService } from '../../services';

@Component({
  tag: 'rcm-editorial-big-item-image',
  styleUrl: 'rcm-editorial-big-item-image.scss',
  shadow: true,
})
export class RcmEditorialBigItemImage {
  @Prop() imageSrc: RcmImageProp | string;

  @Prop() headline: string;

  @Prop() text: string;

  @Prop() flipped = false;

  @Prop() linkText: string;

  @Prop() link: string;

  @Prop() downloadText: string;

  @Prop() download: string;

  @Prop() squareImage = false;

  @Prop() isArticle = false;

  @Prop() shadow = false;

  /** Manage if title/ caption should be displayed */
  @Prop() public showCaption = false;

  /** Manage if copyright should be displayed */
  @Prop() public showCopyright = false;

  render() {
    return (
      <Host>
        <rcm-container class={this.isArticle && 'article-container'} fullWidth={this.isArticle}>
          <rcm-columns class={{ reverse: this.flipped }}>
            {StringService.isValidImageSrc(StringService.parseLink(this.imageSrc)) && (
              <rcm-column span={6} class={`image-container ${this.squareImage ? 'image-container--centered' : ''}`}>
                <rcm-image
                  fullHeight={!this.squareImage}
                  ratio={this.squareImage ? Ratio.SQUARE : Ratio.ORIGINAL}
                  class={{ shadow: this.shadow }}
                  src={this.imageSrc}
                  showCaption={this.showCaption}
                  showCopyright={this.showCopyright}
                ></rcm-image>
              </rcm-column>
            )}
            <rcm-column span={6} class="text-container">
              <rcm-headline level={3} headline={this.headline} color="var(--colors-dark-base)" />
              <p>{this.text}</p>
              <div class="link-container">
                {this.download && this.downloadText && (
                  <rcm-button
                    appearance={ButtonAppearance.UNDERLINE_ICON}
                    text={this.downloadText}
                    link={{ src: (StringService.stringToObject(this.download) as Multilink).src, target: Target.BLANK }}
                    icon="download"
                    download={true}
                    parentComponent="rcm-editorial-big-item-image"
                  ></rcm-button>
                )}
                {this.link && this.linkText && (
                  <rcm-button
                    appearance={ButtonAppearance.TERTIARY}
                    text={this.linkText}
                    link={this.link}
                    parentComponent="rcm-editorial-big-item-image"
                  ></rcm-button>
                )}
              </div>
            </rcm-column>
          </rcm-columns>
        </rcm-container>
      </Host>
    );
  }
}
